<script setup>
import FormContainer from "@/Pages/Components/FormContainer.vue";
import {usePage} from "@inertiajs/vue3";
import {useDisplay} from "vuetify";

const {smAndDown} = useDisplay();

defineProps({
    form: {
        type: Object,
        default: {}
    }
})

const { firstExternalContactSources } = usePage().props;
</script>

<template>
    <FormContainer title="Additional comments">
        <v-row>
            <v-col cols="12">
                <v-textarea v-model="form.initialComments" label="Do you have any initial questions?" aria-label="Do you have any initial questions?"/>
            </v-col>
            <v-col cols="12">
                <v-select v-model="form.firstHeard" :class="{'small-font':smAndDown}" :items="firstExternalContactSources" item-title="source" item-value="id" label="Where did you first hear about us?*" aria-label="Where did you first hear about us?*" :error-messages="form.errors.firstHeard" aria-required="true"
                          role="option"/>
            </v-col>
            <v-col cols="12" v-if="firstExternalContactSources.filter(item => item.source == 'Other')[0]?.id === form.firstHeard">
                <v-textarea v-model="form.firstHeardOther" label="Other - please give details" />
            </v-col>
        </v-row>
    </FormContainer>
</template>

<style scoped>
:deep(.v-select.small-font .v-field__field .v-label) {
    font-size: 0.71rem !important;
}
</style>
